import { Box, SimpleGrid } from "@chakra-ui/react";
import View from "views/admin/content/components/View";
import React from "react";

const index = () => {
  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid
        mb="20px"
        columns={{ sm: 1, md: 1 }}
        spacing={{ base: "20px", xl: "20px" }}
      >
        <View />
      </SimpleGrid>
    </Box>
  );
};

export default index;
